import "./Home.css";
import img3 from "../images/img3.webp"
import gift22 from "../images/gift22.jpeg"
import gift3 from "../images/gift3.jpeg"
import img2 from "../images/img2.webp"
import gift1 from "../images/gift.jpeg"
import frames from "../images/collection.webp"
import handmade from "../images/handmadepic.jpg"
import potraitarts from "../images/art.jpg"
import { Fragment } from "react";
import { useNavigate } from "react-router-dom";
import "./Home.css";
const Home = () => {
    const Navigate = useNavigate();
    return (
        <Fragment>
            <div id="carouselExampleFade" class="carousel slide carousel-fade mt-2" data-bs-ride="carousel ">
                <div class="carousel-inner">
                    <div class="carousel-item active">
                        <img src={gift22} class="d-block  image" alt="..." />
                    </div>
                    <div class="carousel-item">
                        <img src={gift3} class="d-block  image" alt="..." />
                    </div>
                    <div class="carousel-item">
                        <img src={gift1} class="d-block  image" alt="..." />
                    </div>
                </div>
                <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleFade" data-bs-slide="prev">
                    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                    <span class="visually-hidden">Previous</span>
                </button>
                <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleFade" data-bs-slide="next">
                    <span class="carousel-control-next-icon" aria-hidden="true"></span>
                    <span class="visually-hidden">Next</span>
                </button>
            </div>
            <div class="container">
                <div class="About-section">
                    <div class="image-sections mx-auto">
                        <img src={img2} alt="" class="sectionimage" />
                        <img src={img3} alt="" class="sectionimage1" />
                    </div>
                    <div class="content-section mx-auto">
                        <h2> <i>Leegifts Clone website</i></h2>
                        <p> <i> Developed By Sujith </i>  </p>
                        <ul>
                            <li>I am a civil engineering graduate with a strong foundation in full stack development, aiming to apply my skills to create impactful solutions.                    </li>
                            <li>I have skills in full stack development, including React.js and Python.
                            </li>
                            <li> I developed a Leegifts clone website fully in React.js, utilizing Retool API for the backend, with DummyJSON for authentication and Redux Toolkit for state management..</li>
                            <li>I am actively pursuing IT job opportunities.</li>
                        </ul>

                    </div>



                </div>
            </div>
            <div className="collection container">
                <div className="frames">
                    <div class="card mx-auto" style={{ width: "22rem", marginTop: "20px" }} onClick={() => {
                        Navigate("/frames")
                    }}>
                        <img src={frames} class="card-img-top" alt="..." />
                        <div class="card-body">
                            <h6 class="card-title"><i>Frames</i></h6>


                        </div>
                    </div>
                    <div class="card mx-auto" style={{ width: "22rem", marginTop: "20px" }} onClick={() => {
                        Navigate("/handmade-gifts")
                    }}>
                        <img src={handmade} class="card-img-top" alt="..." />
                        <div class="card-body">
                            <h6 class="card-title"><i>Handmade Gifts</i></h6>


                        </div>
                    </div>

                    <div class="card mx-auto" style={{ width: "22rem", marginTop: "20px" }} onClick={() => {
                        Navigate("/potrait-arts")
                    }}>
                        <img src={potraitarts} class="card-img-top" alt="..." />
                        <div class="card-body">
                            <h6 class="card-title"><i>Arts and paintings</i></h6>


                        </div>
                    </div>

                </div>

                <button class="btn button-viewall mx-auto d-block" type="button" onClick={() => { Navigate("/collection") }}>View all </button>





            </div>
            <div className="Faq-section container col-8 my-5">
                <div class="accordion" id="accordionPanelsStayOpenExample">
                    <div class="accordion-item">
                        <h2 class="accordion-header" id="panelsStayOpen-headingOne">
                            <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseOne" aria-expanded="true" aria-controls="panelsStayOpen-collapseOne">
                                <i className="fa-regular fa-clock"></i> <span className="ms-4"> Preparation Time </span>
                            </button>
                        </h2>
                        <div id="panelsStayOpen-collapseOne" class="accordion-collapse collapse " aria-labelledby="panelsStayOpen-headingOne">
                            <div class="accordion-body">
                                <ul>
                                    <li>Preparation - 3 to 7 working days</li>
                                    <li>Within Tamilnadu Delivery - 1 or 2 working days after preparation</li>
                                    <li> Outside Tamilnadu Delivery - 2 to 4 working days after preparation (delivery time varies from shipping pincodes and deliver partners)</li>
                                </ul>
                                <p>
                                    Preparation starts only after sharing order id, images and required details over email and email id to be shared along with order id to us over 9962585299 (WhatsApp)
                                </p>                            </div>
                        </div>
                    </div>
                    <div class="accordion-item">
                        <h2 class="accordion-header" id="panelsStayOpen-headingTwo">
                            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseTwo" aria-expanded="false" aria-controls="panelsStayOpen-collapseTwo">
                            <i class="fa-solid fa-tag"></i> <span className="ms-4"> How to place COD order </span>
                            </button>
                        </h2>
                        <div id="panelsStayOpen-collapseTwo" class="accordion-collapse collapse" aria-labelledby="panelsStayOpen-headingTwo">
                            <div class="accordion-body">
                                <p>Unfortunately, we do not currently support Cash on Delivery (COD) for our custom-made products. Every order needs to be paid for via our secure online payment gateway.</p> 
                            </div>
                        </div>
                    </div>
                    <div class="accordion-item">
                        <h2 class="accordion-header" id="panelsStayOpen-headingThree">
                            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseThree" aria-expanded="false" aria-controls="panelsStayOpen-collapseThree">
                            <i class="fa-solid fa-question"></i> <span className="ms-4"> How to share photos and details? </span>
                            </button>
                        </h2>
                        <div id="panelsStayOpen-collapseThree" class="accordion-collapse collapse" aria-labelledby="panelsStayOpen-headingThree">
                            <div class="accordion-body">
                                <p>After placing your order, you can share all the details via Mail leegiftsandletters@gmail.com or via WhatsApp 9500078912 with your order id.</p> 
                            </div>
                        </div>
                    </div>
                    <div class="accordion-item">
                        <h2 class="accordion-header" id="panelsStayOpen-headingFour">
                            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseFour" aria-expanded="false" aria-controls="panelsStayOpen-collapseFour">
                            <i class="fa-solid fa-star"></i><span className="ms-4"> How to request for customisation? </span>
                            </button>
                        </h2>
                        <div id="panelsStayOpen-collapseFour" class="accordion-collapse collapse" aria-labelledby="panelsStayOpen-headingFour">
                            <div class="accordion-body">
                                <p>To ensure your customized product is tailored perfectly, please include all necessary details in the same email or message when placing your order. Our team will carefully review the information provided. This option is applicable to eligible products only.</p> 
                            </div>
                        </div>
                    </div>
                    <div class="accordion-item">
                        <h2 class="accordion-header" id="panelsStayOpen-headingFive">
                            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseFive" aria-expanded="false" aria-controls="panelsStayOpen-collapseFive">
                            <i class="fa-solid fa-plane"></i><span className="ms-4"> Do you offer international shipping? </span>
                            </button>
                        </h2>
                        <div id="panelsStayOpen-collapseFive" class="accordion-collapse collapse" aria-labelledby="panelsStayOpen-headingFive">
                            <div class="accordion-body">
                                <p>At the moment, we do not offer international shipping services. Our products are available for delivery within India. We appreciate your understanding and support.</p> 
                            </div>
                        </div>
                    </div>
                    <div class="accordion-item">
                        <h2 class="accordion-header" id="panelsStayOpen-headingSix">
                            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseSix" aria-expanded="false" aria-controls="panelsStayOpen-collapseSix">
                            <i class="fa-solid fa-box"></i><span className="ms-4"> How can I track the status of my order? </span>
                            </button>
                        </h2>
                        <div id="panelsStayOpen-collapseSix" class="accordion-collapse collapse" aria-labelledby="panelsStayOpen-headingSix">
                            <div class="accordion-body">
                                <p>If your order has been shipped, you will receive a tracking link via email or SMS. This link will provide real-time updates on the status and location of your package. If your order has not been shipped yet, please contact our support team for the most accurate and up-to-date information on your order's status.</p> 
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    )
}
export default Home;